import { TCart } from "@/redux/slices/user/types";
import {
  emitFacebookTrack,
  emitGoogleTrack,
  emitLinkedinTrack,
} from "@helpers/siteTracking/emitters";
import { updateEventNameBasedOnBillingInterval } from "./helper";

export const accountVerification = ({
  currency,
  email,
}: {
  currency: string;
  email: string;
}) => {
  emitGoogleTrack({
    event: "new_registration",
    value: 0,
    currency,
    email,
  });
  // emitFacebookTrack("CompleteRegistration");
  // emitLinkedinTrack("1441049");
};

export const userLoginStatus = ({
  loginStatus,
  userId,
  plan,
  siteVersion,
}: {
  loginStatus?: string;
  userId?: number;
  plan?: string;
  siteVersion?: string;
}) => {
  emitGoogleTrack({
    event: "user_status_determined",
    login_status: loginStatus,
    user_id: userId,
    plan,
    site_version: siteVersion,
  });
};

export const trialVerification = ({
  currency,
  email,
}: {
  currency: string;
  email: string;
}) => {
  emitGoogleTrack({
    event: "free_trial",
    value: 0,
    currency,
    email,
  });
  // emitFacebookTrack("StartTrial");
  // emitLinkedinTrack("1441041");
};

export const successfulTrialUpgrade = ({
  orderId,
  value,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "trial_upgrade",
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("TrialToPackageUpgrade", {
  //   value: value || 0,
  //   order_id: orderId,
  //   currency,
  // });
  // emitLinkedinTrack("1595937");
};

export const successfulPlanPurchase = ({
  orderId,
  value,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "voip_business",
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
};

export const corePurchase = ({
  orderId,
  value,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: updateEventNameBasedOnBillingInterval({
      eventName: "voip_starting_out",
      billing_interval,
    }),
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("VoIPStartingOut", {
  //   value: value || 0,
  //   order_id: orderId,
  //   currency,
  // });
  // emitLinkedinTrack("1418609");
};

export const coreUserPurchase = ({
  orderId,
  value,
  quantity,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  quantity?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: updateEventNameBasedOnBillingInterval({
      eventName: "user_purchase_starting_out",
      billing_interval,
    }),
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("VoIPStartingOut", {
  //   value: value || 0,
  //   quantity: quantity || 0,
  //   order_id: orderId,
  //   currency,
  // });
};

export const standardPurchase = ({
  orderId,
  value,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: updateEventNameBasedOnBillingInterval({
      eventName: "voip_flying_high",
      billing_interval,
    }),
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("VoIPFlyingHigh", {
  //   value: value || 0,
  //   order_id: orderId,
  //   currency,
  // });
  // emitLinkedinTrack("1441025");
};

export const standardUserPurchase = ({
  orderId,
  value,
  quantity,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  quantity?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    quantity: quantity || 0,
    event: updateEventNameBasedOnBillingInterval({
      eventName: "user_purchase_flying_high",
      billing_interval,
    }),
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("UserPurchaseFlyingHigh", {
  //   value: value || 0,
  //   quantity: quantity || 0,
  //   order_id: orderId,
  //   currency,
  // });
};

export const premiumPurchase = ({
  orderId,
  value,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: updateEventNameBasedOnBillingInterval({
      eventName: "voip_enterprise",
      billing_interval,
    }),
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("VoIPEnterprise", {
  //   value: value || 0,
  //   order_id: orderId,
  //   currency,
  // });
  // emitLinkedinTrack("1441033");
};

export const premiumUserPurchase = ({
  orderId,
  value,
  quantity,
  currency,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  quantity?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    quantity: quantity || 0,
    event: updateEventNameBasedOnBillingInterval({
      eventName: "user_purchase_enterprise",
      billing_interval,
    }),
    email: email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
  // emitFacebookTrack("UserPurchaseEnterprise", {
  //   value: value || 0,
  //   quantity: quantity || 0,
  //   currency,
  //   order_id: orderId,
  // });
};

export const numberPurchase = ({
  orderId,
  value,
  quantity,
  event,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  quantity?: number;
  event: string;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    quantity: quantity || 0,
    event: event,
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
};

export const addOnProducts = ({
  orderId,
  value,
  email,
  newCustomer,
  billing_interval,
}: {
  orderId?: any;
  value?: number;
  email: string;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "addon_purchase",
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
};

export const checkoutSuccess = ({
  value,
  currency,
  transactionId,
  tax,
  items,
  newCustomer,
  billing_interval,
}: {
  value: number;
  currency: string;
  transactionId: string | number;
  tax: number;
  items: {
    item_id: string;
    item_name: string;
    item_category: number;
    price: number;
    quantity: number;
  }[];
  newCustomer?: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    event: "purchase",
    ecommerce: {
      transaction_id: transactionId,
      value,
      tax,
      currency,
      items,
      newCustomer,
      billing_interval: billing_interval,
    },
  });
  // emitFacebookTrack("Purchase", {
  //   value,
  //   currency,
  //   order_id: transactionId,
  // });
};

export const planPurchase = ({
  value,
  email,
  orderId,
  newCustomer,
  billing_interval,
}: {
  value: number;
  email: string;
  orderId: string | number;
  newCustomer: boolean;
  billing_interval?: string;
}) => {
  emitGoogleTrack({
    event: "plan_purchase",
    orderId: orderId,
    orderValue: value,
    email,
    new_customer: newCustomer,
    billing_interval: billing_interval,
  });
};

export const resellerPackage = ({
  orderId,
  value,
  email,
  newCustomer,
}: {
  orderId?: any;
  value?: number;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "reseller",
    email,
    new_customer: newCustomer,
  });
};

export const domainPurchase = ({
  orderId,
  value,
  currency,
  email,
  newCustomer,
}: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "domain_registration",
    email,
    new_customer: newCustomer,
  });
  // emitFacebookTrack("DomainReg", {
  //   value,
  //   order_id: orderId,
  //   currency,
  // });
};

export const domainTransfer = ({
  orderId,
  value,
  currency,
  email,
  newCustomer,
}: {
  orderId?: any;
  value?: number;
  currency?: string;
  email: string;
  newCustomer: boolean;
}) => {
  emitGoogleTrack({
    orderId: orderId || "", // Insert the order ID, if applicable
    orderValue: value || 0,
    event: "domain_transfer",
    email,
    new_customer: newCustomer,
  });
  // emitFacebookTrack("DomainTransfer", {
  //   value,
  //   order_id: orderId,
  //   currency,
  // });
};

export const addToCart = () => {
  emitFacebookTrack("AddToCart");
};

export const initiateCheckout = () => {
  emitFacebookTrack("InitiateCheckout");
};

export const beginCheckout = ({
  value,
  currency,
  tax,
  items,
  billing_interval,
}: {
  value: number;
  currency: string;
  tax: number;
  billing_interval?: string;
  items: {
    item_id: string;
    item_name: string;
    item_category: number;
    price: number;
    quantity: number;
  }[];
}) => {
  emitGoogleTrack({
    event: "begin_checkout",
    ecommerce: {
      value,
      tax,
      currency,
      items,
      billing_interval,
    },
  });
};

export const addPaymentInfo = () => {
  emitGoogleTrack({
    event: "add_payment_info",
  });
};
